import { motion } from "framer-motion";
import chevronGold from "@/assets/brand/Chevron_Gold.svg";

interface WhySectionProps {
  headline?: string | null;
  description?: string | null;
  items?: string[];
}

export function WhySection({ headline, description, items = [] }: WhySectionProps) {
  if (!headline && items.length === 0) return null;

  return (
    <section className="py-10 md:py-14 bg-muted">
      <div className="container-padding mx-auto text-center max-w-3xl">
        {headline && (
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5 }}
            className="text-3xl md:text-4xl font-bold text-foreground mb-6"
          >
            {headline}
          </motion.h2>
        )}
        {description && (
          <motion.p
            initial={{ opacity: 0, y: 15 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.5, delay: 0.1 }}
            className="text-lg text-muted-foreground mb-10"
          >
            {description}
          </motion.p>
        )}
        {items.length > 0 && (
          <div className="grid sm:grid-cols-2 gap-4 text-left">
            {items.map((item, i) => (
              <motion.div
                key={item}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.4, delay: i * 0.08 }}
                className="flex items-start gap-3 p-4 bg-background rounded-xl"
              >
                <img src={chevronGold} alt="" aria-hidden className="h-5 w-auto shrink-0 mt-0.5" />
                <span className="text-foreground font-medium">{item}</span>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
